import { render, staticRenderFns } from "./Ultrasound.vue?vue&type=template&id=0602acf8&scoped=true"
import script from "./Ultrasound.vue?vue&type=script&lang=js"
export * from "./Ultrasound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0602acf8",
  null
  
)

export default component.exports